namespace RioERP.Products {
    export interface CategoryRow {
        Id?: number;
        Name?: string;
        IsWebsiteCategory?: boolean;
        WebsiteCategoryId?: string;
        Description?: string;
        ParentId?: number;
        ParentName?: string;
        IsActive?: boolean;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace CategoryRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Products.Category';
        export const lookupKey = 'Products.Category';

        export function getLookup(): Q.Lookup<CategoryRow> {
            return Q.getLookup<CategoryRow>('Products.Category');
        }
        export const deletePermission = 'Products:ProductsManagement:Modify';
        export const insertPermission = 'Products:ProductsManagement:Modify';
        export const readPermission = 'Products:ProductsManagement:View';
        export const updatePermission = 'Products:ProductsManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            IsWebsiteCategory = "IsWebsiteCategory",
            WebsiteCategoryId = "WebsiteCategoryId",
            Description = "Description",
            ParentId = "ParentId",
            ParentName = "ParentName",
            IsActive = "IsActive",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
